<template>
  <div>
    <v-container class="ml-10">
      <p class="display-1 mt-7">부가서비스</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        내 쇼핑몰에 적합한 맞춤 서비스가 가능합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        정품 인증 코드와 연결된 쇼핑몰의 정품인증화면(PC,모바일)과 인쇄
        템플릿(A4, 라벨용지) 별도 제작이 가능합니다.
      </p>

      <p class="mt-8 mb-0 title font-weight-light font-weight-bold">
        01. 쇼핑몰 정품인증화면 커스텀 제작
      </p>
      <p class="mt-2 mb-0 subtitle-2 font-weight-medium">
        PC와 모바일쇼핑몰 정품 등록 및 인증 내역 화면을 쇼핑몰에 맞게 별도
        디자인한 화면으로 제작이 가능합니다.
      </p>

      <p class="mt-8 mb-0 title font-weight-light font-weight-bold">
        02. 인쇄 템플릿 커스텀 제작 (a4/라벨용지)
      </p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
        소량 인쇄를 하시는 경우에 더욱 효과적입니다.
      </p>
      <p class="mb-0 subtitle-2 font-weight-medium">
        [정품 QR 코드 인쇄 설정] 메뉴에 템플릿을 추가하여 사용이 가능합니다.
      </p>
      <p class="mb-0 subtitle-2 font-weight-medium">
        원하시는 용지 사이즈에 맞는 인쇄 템플릿 제작이 가능합니다.
      </p>

      <p class="mt-8 mb-0 title font-weight-light font-weight-bold">
        03. 커스텀 추가 기능
      </p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
        쇼핑몰 특성에 맞게 별도 커스텀 기능이 필요한 경우 제작이 가능합니다.
      </p>

      <!--
      <p class="mt-8 mb-0 title font-weight-light font-weight-bold">03. 정품라벨스티커 제작</p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium">상품에 부착이 가능한 별도 디자인된 정품라벨스티커를 제작할 수 있습니다.</p>
      <p
        class="mb-0 subtitle-2 font-weight-medium"
      >생성하신 정품 인증 코드를 기반으로 제작되며, 퀄리티 있는 디자인의 정품라벨스티커를 고객에게 제공할 수 있습니다.</p>

      <p class="mt-8 mb-0 title font-weight-light font-weight-bold">04. 정품보증서 제작</p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium">제품과 함께 동봉하여 전달하는 정품보증서를 제작할 수 있습니다.</p>
      <p
        class="mb-0 subtitle-2 font-weight-medium"
      >생성하신 정품 인증 코드를 기반으로 제작되며, 퀄리티 있는 디자인의 정품보증서를 고객에게 제공할 수 있습니다.</p>
      -->
      <div class="my-2 mt-8">
        <v-btn depressed large color="primary" @click="additionalServiceApply()"
          >부가서비스 신청하기</v-btn
        >
      </div>
    </v-container>
  </div>
</template>

<script>
import CommonMixin from "@/mixins/CommonMixin.js";
export default {
  data: () => ({}),
  methods: {
    additionalServiceApply: function() {
      window.open("https://forms.gle/JxcTQWeHZ8V7oQQQ7", "_blank");
    },
  },
  mixins: [CommonMixin],
};
</script>
